module.exports = __webpack_public_path__ + "img/IntelligentManufacturing.f26d0944.png";